import { CloseButton } from "@ng-mw/reol/components/Modal"
import "@ng-mw/reol/components/Tooltip/Tooltip.scss"
import "./style/positionable-tooltip.scss"
import useOnClickOutside from "@ng-mw/reol/utils/useOnClickOutside"

import classNames from "classnames"
import React, {
    CSSProperties,
    ReactElement,
    RefObject,
    useId,
    useRef,
    useState,
    type ReactNode,
} from "react"

export type TooltipPositionType = "left" | "center" | "right"
export type TooltipWidthType = "narrow" | "wide"

interface PositionableTooltipProps {
    anchorRef?: RefObject<HTMLUnknownElement | null>

    /** Additional css classes */
    className?: string

    /** Position of the Tooltip bottom pointer */
    position?: TooltipPositionType

    isBelow?: boolean

    /** Text which will be concatenated as follows: `"{text} {linkText}"` */
    text?: ReactNode

    /** Include close-button in Tooltip  */
    isCloseButtonVisible?: boolean

    /** Components to display  */
    body?: ReactNode

    /** Tooltip width */
    width?: TooltipWidthType

    /** Callback after close */
    onClose?: () => void

    initiallyVisible?: boolean

    isInverted?: boolean
    offsetLeft?: string
    offsetTop?: string
    leftCorrection?: number
    topCorrection?: number
}

const PositionableTooltip = ({
    anchorRef,
    // children,
    className,
    position = "left",
    isBelow = false,
    text = "Nyhet!",
    // isTooltipActive = true,
    // isBlockElement = false,
    // isInlineElement = false,
    isCloseButtonVisible = false,
    width = "narrow",
    onClose = () => undefined,
    body = null,
    initiallyVisible = false,
    isInverted = false,
    leftCorrection = 0,
    topCorrection = 0,
    offsetLeft = "0",
    offsetTop = "0",
}: PositionableTooltipProps): ReactElement | null => {
    const [isTooltipVisible, setIsTooltipVisible] = useState(initiallyVisible)
    const toolTip = useRef<HTMLDivElement>(null)
    const uniqueId = useId()

    const hideTooltip = () => {
        setIsTooltipVisible(false)
        onClose()
    }

    useOnClickOutside(
        toolTip,
        () => {
            hideTooltip()
        },
        undefined,
    )

    // useEffect(() => {
    //     if (!isTooltipActive) {
    //         return
    //     }
    //     toolTip?.current?.focus()
    // }, [isTooltipActive])

    // if (!isTooltipActive) {
    //     // Ignore useless fragment because it's needed to
    //     // turn strings and numbers etc into a valid return value.
    //     // eslint-disable-next-line react/jsx-no-useless-fragment
    //     return <>{children}</>
    // }

    const elementClassNames = classNames(
        "ngr-tooltip",
        "positionable-tooltip",
        `ngr-tooltip--${position}`,
        className,
        {
            "ngr-tooltip--visible": isTooltipVisible,
            "ngr-tooltip--inverted": isInverted,
            "ngr-tooltip--below": isBelow,
            "ngr-tooltip--width-narrow": width === "narrow",
            "ngr-tooltip--width-wide": width === "wide",
        },
    )

    // if(!anchorRef.current) {
    //     return null
    // }

    const wrapperStyle: CSSProperties = anchorRef?.current
        ? {
              position: "absolute",
              left: `${
                  anchorRef.current.offsetLeft +
                  leftCorrection +
                  anchorRef.current.offsetWidth * 0.5
              }px`,
              top: `${
                  anchorRef.current.offsetTop + topCorrection + anchorRef.current.offsetHeight * 0.5
              }px`,
              width: "0",
              height: "0",
              // width: `5px`,
              // height: "5px",
              // background: "rgba(255, 0,0,0.3)",
          }
        : {
              position: "absolute",
              left: offsetLeft,
              top: offsetTop,
              width: "0",
              height: "0",
              // width: `5px`,
              // height: "5px",
              // background: "rgba(255, 0,0,0.3)",
              zIndex: 99,
          }

    return (
        <div style={wrapperStyle}>
            <div
                className={elementClassNames}
                role="tooltip"
                id={uniqueId}
                ref={isTooltipVisible ? toolTip : null}
            >
                {isCloseButtonVisible ? (
                    <CloseButton
                        className="ngr-tooltip__close-button"
                        onClick={hideTooltip}
                    />
                ) : null}
                <span className="ngr-tooltip__text">
                    {text}
                    {body ? <div className="ngr-tooltip__body">{body}</div> : null}
                </span>
            </div>
        </div>
    )
}

export default PositionableTooltip
